import { atom } from "recoil";

export const isInternetOnState = atom({
  key: "isInternetOnState",
  default: true,
});
